import axios from 'axios';
import qs from 'qs'

const getBaseURL = async () => {
  try {
    const response = await fetch('server.json');
    const data = await response.json();
    return data.baseURL; // 返回 baseURL
    
  } catch (error) {
    console.error('Error fetching baseURL:', error);
  }
};
const baseURL = await getBaseURL(); // 等待获取 baseURL
export const myParam = baseURL;

// 配置axios
const axiosOption = {
  timeout: 1000 * 30,
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: '*/*',
    "Authorization": `Bearer ${localStorage.getItem('aicsMng_token')}`
  },
};

const axiosInstance = axios.create(axiosOption);
axiosInstance.interceptors.request.use(
  config => {
    // 在请求头中添加 aicsMng_token，但只对非登录请求添加
    if (config.url !== '/login') {
      const aicsMng_token = localStorage.getItem('aicsMng_token');
      if (aicsMng_token) {
        config.headers.Authorization = `Bearer ${aicsMng_token}`;
      }
    }
    if (config.data && config.method === "get") {
      var params = [];
      for (const key in config.data) {
        var val = config.data[key];
        if (val !== undefined && val !== "") params.push(`${key}=${encodeURIComponent(val)}`);
      }
      const queryString = params.join('&');
      if(queryString) config.url += `?${queryString}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 请求拦截
export default axiosInstance;